// Client mirror of functions-common/src/repeat/types.ts. Keep in sync.

export type CadenceKind =
  | 'DAILY'
  | 'WEEKLY'
  | 'MONTHLY'
  | 'ON_DEMAND'
  | 'PER_SHIFT'
  | 'QUARTERLY'
  | 'YEARLY'
  | 'EVERY_N_DAYS'

export type Cadence =
  | { kind: 'DAILY' }
  | { kind: 'WEEKLY' }
  | { kind: 'MONTHLY' }
  | { kind: 'ON_DEMAND'; runId?: string }
  | { kind: 'PER_SHIFT'; shiftId: string }
  | { kind: 'QUARTERLY' }
  | { kind: 'YEARLY' }
  | { kind: 'EVERY_N_DAYS'; intervalDays: number; anchorDayKey: string }
  | 'DAILY'
  | 'WEEKLY'
  | 'MONTHLY'
  | 'ON_DEMAND'
  | 'PER_SHIFT'
  | 'QUARTERLY'
  | 'YEARLY'
  | 'EVERY_N_DAYS'

export class CadenceNotBuiltError extends Error {
  readonly cadenceKind: string
  constructor(cadenceKind: string) {
    super(`Cadence not built yet: ${cadenceKind}`)
    this.name = 'CadenceNotBuiltError'
    this.cadenceKind = cadenceKind
  }
}

export interface RecurringWindowInput {
  startDate?: string | null
  endDate?: string | null
  parentElementId?: string | null
  syncedAt?: unknown
  repeatPaused?: boolean | null
}

export interface RepeatItemInput {
  id: string
  title?: string | null
  checklistType?: string | null
  isCompleted?: boolean | null
  workflowStatus?: string | null
  deletedAt?: unknown | null
  nodeKind?: string | null
  gateInputIds?: readonly string[] | null
  dependencyNodeIds?: readonly string[] | null
  prerequisites?: readonly string[] | null
  blockedByNodeIds?: readonly { targetId: string }[] | null
  recurringWindow?: RecurringWindowInput | null
  repeatPaused?: boolean | null
  repeatPausedReason?: string | null
  notRequiredFrom?: string | null

  // Proof / location / resources / external blockers pass-through
  requiresProofFile?: boolean | null
  proofFileUrl?: string | null
  proofSubmissionId?: string | null
  requiresLocationPin?: boolean | null
  verifiedCoordinates?: unknown | null
  resourceGateStatus?: string | null
  blockedByExternal?: { targetId?: string } | null
}

export interface RepeatPageCompletion {
  isCompleted?: boolean | null
  workflowStatus?: string | null
  completedAt?: string | null
  completedById?: string | null
  completedByName?: string | null
}

export interface RepeatPageDoc {
  pageKey: string
  completions?: Record<string, RepeatPageCompletion> | null
}

export type RepeatPagesInput =
  | ReadonlyMap<string, RepeatPageDoc>
  | readonly RepeatPageDoc[]
  | Record<string, RepeatPageDoc>

export type LockReasonCode =
  | 'DEPENDENCY_INCOMPLETE'
  | 'DEPENDENCY_MISSING'
  | 'PROOF_REQUIRED'
  | 'LOCATION_REQUIRED'
  | 'RESOURCE_WARNING'
  | 'EXTERNAL_BLOCKER'
  | 'WINDOW_ENDED'

export interface LockReason {
  code: LockReasonCode
  targetId?: string
  title?: string
  inBin?: boolean
  missed?: string[]
  missedPeriods?: string[]
}

export interface LockStateResult {
  isBlocked: boolean
  isLocked?: boolean
  reasons: LockReason[]
  blockerCount: number
}
